module.exports = __webpack_public_path__ + "img/Blister Pack.9e03f7f9.png";